<template>
  <div class="container">
    <h4 class="cardD">Finalización del proceso</h4>

    <b-row v-if="!procesoTerminado">
      <b-button block class="orange-btn" @click="$emit('terminar-proceso')">Terminar proceso</b-button>
    </b-row>
    <b-alert v-else variant="success" class="text-center" show>Proceso Terminado</b-alert>
  </div>
</template>

<script>
export default {
  name: "ProcesoTerminado",

  props: {
    procesoTerminado: { type: Boolean },
  },
};
</script>
